/**
 * Register the service worker for PWA/offline support.
 * Update detection is handled by PWAContext for proper UI.
 */
export function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', async () => {
      try {
        const registration = await navigator.serviceWorker.register('/sw.js', { scope: '/' });
        console.log('[PWA] Service worker registered:', registration.scope);

        // Check for updates periodically
        setInterval(() => {
          registration.update();
        }, 60 * 60 * 1000); // every hour
      } catch (err) {
        console.warn('[PWA] Service worker registration failed:', err.message);
      }
    });
  }
}

/**
 * Unregister all service workers (for debugging)
 */
export async function unregisterServiceWorker() {
  if ('serviceWorker' in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    for (const registration of registrations) {
      await registration.unregister();
    }
    console.log('[PWA] Service workers unregistered');
  }
}
